<template>
  <v-app id="app">
    <v-navigation-drawer
      app
      right
      absolute
      v-model="drawer"
      v-if="$vuetify.breakpoint.smAndDown"
      class="pa-3 pt-16"
    >
      <h3>منو کاربری</h3>
      <v-divider class="my-2" />
      <v-list nav dense>
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item router to="/">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>صفحه اصلی</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="!user"
            router
            :to="{ name: 'Signin', query: { redirect: this.$router.fullPath } }"
          >
            <v-list-item-icon>
              <v-icon>mdi-login-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ورود</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="!user" router to="/Register">
            <v-list-item-icon>
              <v-icon>mdi-account-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ثبت نام</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="!user && this.$store.getters.hasDefaultPortal"
            router
            to="/SchoolRegister"
          >
            <v-list-item-icon>
              <v-icon>mdi-home-city-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ثبت نام مدرسه‌ای</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="user && user.type != 'مدرسه'" router to="/Profile">
            <v-list-item-icon>
              <v-icon>mdi-dots-horizontal-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ user.firstname + " " + user.lastname }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="user && user.type === 'ادمین'"
            router
            :to="{ name: 'UsersReport' }"
          >
            <v-list-item-icon>
              <v-icon>mdi-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>بخش مدیریت</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="user && user.type === 'مدرسه'"
            router
            :to="{ name: 'CreateSchoolOrder' }"
          >
            <v-list-item-icon>
              <v-icon>mdi-credit-card-settings-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>کنترل پنل مدرسه</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="user && user.type === 'پورتال'"
            router
            :to="{ name: 'Portal' }"
          >
            <v-list-item-icon>
              <v-icon>mdi-credit-card-settings-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>پنل پورتال</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="user && user.type === 'ناظر'"
            router
            :to="{ name: 'SupervisorUsers' }"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-chart-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>گزارشات</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="user" @click="handleSingoutUser">
            <v-list-item-icon>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>خروج</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app flat dense v-if="whereAmI">
      <div class="d-flex align-center" v-if="$vuetify.breakpoint.smAndDown">
        <v-app-bar-nav-icon @click="drawer = !drawer" />
        <div class="grey--text text-h6 align-self-center">
          سامانه توسعه سواد خواندن
        </div>
      </div>
      <v-row class="d-flex align-center" v-if="$vuetify.breakpoint.mdAndUp">
        <div class="grey--text text-h6 text-no-wrap">
          سامانه توسعه سواد خواندن
        </div>
        <div class="d-flex justify-end flex-fill py-0">
          <div class="d-flex">
            <v-btn dense text router to="/">
              <v-icon>mdi-home</v-icon>
              <div class="mr-2">صفحه اصلی</div>
            </v-btn>
            <span v-if="!user" class="d-flex flex-nowrap">
              <v-btn
                dense
                text
                router
                :to="{
                  name: 'Signin',
                  query: { redirect: this.$route.fullPath }
                }"
              >
                <v-icon>mdi-login-variant</v-icon>
                <div class="mr-2">ورود</div>
              </v-btn>
              <v-btn dense text router to="/Register">
                <v-icon>mdi-account-plus</v-icon>
                <div class="mr-2">ثبت نام</div>
              </v-btn>
              <v-btn
                v-if="this.$store.getters.hasDefaultPortal"
                dense
                text
                router
                to="/SchoolRegister"
              >
                <v-icon>mdi-home-city-outline</v-icon>
                <div class="mr-2">ثبت نام مدرسه‌ای</div>
              </v-btn>
            </span>
            <span v-if="user">
              <v-btn
                v-if="user.type != 'مدرسه'"
                dense
                text
                router
                to="/Profile"
              >
                <v-icon class="rotate-180"
                  >mdi-dots-horizontal-circle-outline</v-icon
                >
                <div class="mr-2">
                  {{ user.firstname + " " + user.lastname }}
                </div>
              </v-btn>
              <v-btn
                v-if="user.type === 'ادمین'"
                dense
                text
                router
                :to="{ name: 'UsersReport' }"
              >
                <v-icon class="rotate-180">mdi-cog-outline</v-icon>
                <div class="mr-2">بخش مدیریت</div>
              </v-btn>
              <v-btn
                v-if="user.type === 'مدرسه'"
                dense
                text
                router
                :to="{ name: 'SchoolOrders' }"
              >
                <v-icon class="rotate-180"
                  >mdi-credit-card-settings-outline</v-icon
                >
                <div class="mr-2">کنترل پنل مدرسه</div>
              </v-btn>
              <v-btn
                v-if="user.type === 'پورتال'"
                dense
                text
                router
                :to="{ name: 'Portal' }"
              >
                <v-icon class="rotate-180"
                  >mdi-credit-card-settings-outline</v-icon
                >
                <div class="mr-2">پنل پورتال</div>
              </v-btn>
              <v-btn
                v-if="user.type === 'نمایندگی'"
                dense
                text
                router
                :to="{ name: 'AgentActivedSchools' }"
              >
                <v-icon class="rotate-180"
                  >mdi-credit-card-settings-outline</v-icon
                >
                <div class="mr-2">پنل نمایندگی</div>
              </v-btn>
              <v-btn
                v-if="user.type == 'ناظر'"
                dense
                text
                router
                :to="{ name: 'SupervisorUsers' }"
              >
                <v-icon class="rotate-180"> mdi-file-chart-outline </v-icon>
                <div class="mr-2">گزارشات</div>
              </v-btn>
              <v-btn @click="handleSingoutUser" dense text>
                <v-icon class="rotate-180">mdi-logout-variant</v-icon>
                <div class="mr-2">خروج</div>
              </v-btn>
            </span>
          </div>
        </div>
      </v-row>
    </v-app-bar>

    <v-main app :class="whereAmI ? '' : 'align-center'">
      <v-container>
        <message-alert
          :message="message"
          v-if="messageState"
          :type="messageType"
        />
        <router-view />
      </v-container>
    </v-main>

    <v-footer class="d-flex flex-column justify-end white--text mt-16">
      <div class="mb-5 text-center">
        <a
          referrerpolicy="origin"
          target="_blank"
          href="https://trustseal.enamad.ir/?id=184468&amp;Code=Kjr7zqWv4Iy7tlTrXb5r"
          ><img
            referrerpolicy="origin"
            src="https://Trustseal.eNamad.ir/logo.aspx?id=184468&amp;Code=Kjr7zqWv4Iy7tlTrXb5r"
            alt=""
            style="cursor: pointer"
            id="Kjr7zqWv4Iy7tlTrXb5r"
        /></a>
      </div>
      <div v-if="this.$store.getters.hasDefaultPortal">
        کلیه حقوق متعلق به
        <strong class="px-1">مدارس یادگیرنده مرآت</strong>
        می باشد
      </div>
      <div v-else>
        <strong>آدرس مدرسه: </strong>
        <span v-if="this.$store.getters.portal">
          {{ this.$store.getters.portal.address }}
        </span>
        /
        <strong> تلفن تماس مدرسه:</strong>
        <span v-if="this.$store.getters.portal">
          {{ this.$store.getters.portal.tel }}
        </span>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "app-component",
  data() {
    return {
      drawer: false
    };
  },
  computed: {
    ...mapGetters(["user", "error", "message", "messageState", "messageType"]),
    whereAmI() {
      const routerlayout = this.$route.meta.layout;
      if (routerlayout == "none") {
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    this.$store.dispatch("checkUser");
    this.$store.dispatch("portal");
    this.setToken();
  },
  updated() {
    this.setToken();
  },
  methods: {
    handleSingoutUser() {
      this.$store.dispatch("signoutUser");
    },
    setToken() {
      this.$api.defaults.headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$cookies.get("jwt")
      };
    }
  }
};
</script>
<style>
#app {
  background: url("~@/assets/images/bg.svg") no-repeat top center;
  transform: scale(1);
  background-color: #f6f7f8;
  overflow-x: hidden;
}
.v-main {
  min-height: 810px;
}
footer {
  background: url("~@/assets/images/footer-bg.svg") no-repeat top center;
  transform: scale(1);
  background-color: transparent;
  height: 476px;
}
.dastnevis {
  font-family: "iransansdn" !important;
}
.re-rounded {
  border-radius: 15px;
}
.re-shadow {
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
}
.v-data-table th {
  padding: 15px 0 !important;
}
.v-data-table th,
.v-data-table th span,
.v-data-table td {
  white-space: nowrap;
}
.v-data-table__mobile-row {
  height: auto !important;
}
.v-data-table__mobile-row__cell {
  margin-right: 10%;
}
.plyr {
  height: auto !important;
}
</style>
